export enum MessageType {
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  DOCUMENT = 'document',
  FILE = 'file',
  LOCATION = 'location',
  STICKER = 'sticker',
  CONTACT = 'contact',
  INTERACTION = 'interaction',
  TEMPLATE = 'template',
  QUICK_REPLY = 'quick_reply',
  LIST_REPLY = 'list_reply',
  BUTTON_REPLY = 'button_reply',
}

export enum MessageSourceType {
  ENTRANTE = 'ENTRANTE',
  SALIENTE = 'SALIENTE',
  TEMPLATE = 'TEMPLATE',
}

export enum MessageStatus {
  PENDING = 'PENDING',
  ENQUEUED = 'ENQUEUED',
  SENT = 'SENT',
  SEND = 'SEND',
  DELIVERED = 'DELIVERED',
  READ = 'READ',
  FAILED = 'FAILED',
}

export enum ChatStatus {
  BOT = 'BOT',
  PENDING = 'PENDING',
  ATTENTION = 'ATENTION',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISH = 'FINISH',
  AUTO_CLOSED = 'AUTO_CLOSED',
  ABANDON = 'ABANDON',
  EXPIRE = 'EXPIRE',
  TEMPLATE = 'TEMPLATE',
  TRANSFERRING = 'TRANSFERRING',
  TRANSFER_REJECTED = 'TRANSFER_REJECTED',
}

export enum WebSocketEventType {
  SEND_MESSAGE = 'SEND_MESSAGE',
  ENTER_TO_CHAT = 'ENTER_TO_CHAT',
  EXIT_TO_CHAT = 'EXIT_TO_CHAT',
  END_TO_CHAT = 'END_TO_CHAT',
  READ_CHAT = 'READ_CHAT',
  SEND_FILE = 'SEND_FILE',
  SEND_TEMPLATE = 'SEND_TEMPLATE',
  INTERACTION_MESSAGE = 'INTERACTION_MESSAGE',
  TRANSFER_TO_USER = 'TRANSFER_TO_USER',
  TRANSFER_TO_CAMPAIGN = 'TRANSFER_TO_CAMPAIGN',
  TRANSFER_TO_BOT = 'TRANSFER_TO_BOT',
  CONFIRM_TRANSFER = 'CONFIRM_TRANSFER',
}

export enum WebSocketEventName {
  MESSAGE_EVENT = 'MESSAGE_EVENT',
  MESSAGE_STATUS_EVENT = 'MESSAGE_STATUS_EVENT',
  USER_SEND_TEMPLATE_MESSAGE = 'USER_SEND_TEMPLATE_MESSAGE',
  NEW_CHAT = 'NEW_CHAT',
  NEW_CHAT_TEMPLATE = 'NEW_CHAT_TEMPLATE',
  USER_ENTRY_CHAT = 'USER_ENTRY_CHAT',
  USER_TOOK_CHAT = 'USER_TOOK_CHAT',
  USER_EXIT_TO_CHAT = 'USER_EXIT_TO_CHAT',
  INTERACTION = 'INTERACTION',
  REQUEST_TRANSFER = 'REQUEST_TRANSFER',
  TRANSFER_ACCEPTED = 'TRANSFER_ACCEPTED',
  CHAT_TRANSFERRED_TO_CAMPAIGN = 'CHAT_TRANSFERRED_TO_CAMPAIGN',
  CHAT_TRANSFERRED_TO_BOT = 'CHAT_TRANSFERRED_TO_BOT',
  CHAT_FINISHED = 'CHAT_FINISHED',
  CHAT_UPDATED = 'CHAT_UPDATED',
  CHAT_CLOSED_BY_TIMEOUT_CLIENT = 'CHAT_CLOSED_BY_TIMEOUT_CLIENT',
  CHAT_RELEASED_BY_USER_TIMEOUT = 'CHAT_RELEASED_BY_USER_TIMEOUT',
  CHAT_RELEASED_BY_USER_LOGOUT = 'CHAT_RELEASED_BY_USER_LOGOUT',
  CHAT_RELEASED_BY_BULK_TEMPLATE = 'CHAT_RELEASED_BY_BULK_TEMPLATE',
  CHAT_EXPIRED_BY_META_WINDOW = 'CHAT_EXPIRED_BY_META_WINDOW',
  TEMPLATE_SEND_BLOCKED = 'TEMPLATE_SEND_BLOCKED',
  TEMPLATE_SEND_FAILED = 'TEMPLATE_SEND_FAILED',
  AGENT_EJECTED_FROM_CAMPAIGNS = 'AGENT_EJECTED_FROM_CAMPAIGNS',
  AGENT_PAUSE_CHANGED_BY_SUPERVISOR = 'AGENT_PAUSE_CHANGED_BY_SUPERVISOR',
}

export enum UserRole {
  ADMIN = 'ADMIN',
  OPERATOR = 'OPERATOR',
}

export enum WaitingTimeSeverity {
  SUCCESS = 'success',
  INFO = 'info',
  WARN = 'warn',
  DANGER = 'danger',
  CRITICAL = 'critical',
}
